import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-reglement',
    templateUrl: './reglement.component.html',
    styleUrls: ['./reglement.component.scss']
})
export class ReglementComponent implements OnInit {

    constructor() {}

    ngOnInit() {
    }
    
}
